module.exports = __webpack_public_path__ + "static/media/9DESA6.7699b4b6.jpg";